import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomeownerCheckup from "@/pages/HomeownerCheckup";

export const Route = createFileRoute("/homeowner-checkup")({
  head: () => seoHead("/homeowner-checkup"),
  component: HomeownerCheckup,
});
